import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.entities, (entity, index) => {
    return (_openBlock(), _createBlock("div", {
      class: "expandable-entities",
      key: index
    }, [
      _createVNode("h4", {
        class: "entity-item-container",
        style: { 'border-left': `10px solid ${entity.color}` },
        draggable: "true",
        onDragstart: ($event: any) => (_ctx.onDragStart($event, entity)),
        "data-test": 'entity-container-' + entity.id
      }, [
        _withDirectives(_createVNode("i", {
          class: [_ctx.getIconCls(entity.attributes.iconCls), "p-mx-2"]
        }, null, 2), [
          [
            _directive_tooltip,
            _ctx.$t(`qbe.entities.types.${entity.attributes.iconCls}`),
            void 0,
            { top: true }
          ]
        ]),
        _createVNode("span", {
          class: "kn-flex",
          onClick: ($event: any) => (_ctx.expandEntity(entity)),
          "data-test": 'expand-' + entity.id
        }, _toDisplayString(entity.text), 9, ["onClick", "data-test"]),
        _withDirectives(_createVNode(_component_Button, {
          icon: "fas fa-info",
          class: "p-button-text p-button-rounded p-button-plain ",
          onClick: ($event: any) => (_ctx.$emit('showRelationDialog', entity))
        }, null, 8, ["onClick"]), [
          [
            _directive_tooltip,
            _ctx.$t('qbe.entities.relations'),
            void 0,
            { top: true }
          ]
        ]),
        (entity.expanded)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "pi pi-chevron-up",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: ($event: any) => (entity.expanded = false)
            }, null, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "pi pi-chevron-down",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: ($event: any) => (entity.expanded = true)
            }, null, 8, ["onClick"]))
      ], 44, ["onDragstart", "data-test"]),
      _withDirectives(_createVNode("ul", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(entity.children, (child, index) => {
          return (_openBlock(), _createBlock("li", {
            style: { 'border-left': `5px solid ${child.color}` },
            key: index,
            draggable: "true",
            onClick: ($event: any) => (_ctx.$emit('entityChildClicked', child)),
            onDragstart: ($event: any) => (_ctx.onDragStart($event, child))
          }, [
            _withDirectives(_createVNode("i", {
              class: [_ctx.getIconCls(child.attributes.iconCls), "p-mx-2"]
            }, null, 2), [
              [
                _directive_tooltip,
                _ctx.$t(`qbe.entities.types.${child.attributes.iconCls}`),
                void 0,
                { top: true }
              ]
            ]),
            _createVNode("span", {
              "data-test": 'entity-' + entity.id
            }, _toDisplayString(child.text), 9, ["data-test"]),
            _createVNode(_component_Button, {
              icon: "fas fa-filter",
              class: [{ 'qbe-active-filter-icon': _ctx.fieldHasFilters(child) }, "p-button-text p-button-rounded p-button-plain p-ml-auto"],
              onClick: _withModifiers(($event: any) => (_ctx.openFiltersDialog(child)), ["stop"]),
              "data-test": 'child-' + child.id
            }, null, 8, ["class", "onClick", "data-test"])
          ], 44, ["onClick", "onDragstart"]))
        }), 128))
      ], 512), [
        [_vShow, entity.expanded]
      ])
    ]))
  }), 128))
}